export default __webpack_public_path__ + "_/images/app/android/android-en-3-6bb7d600899e1550a6bef31b731279ade51577ad940bb1eb5d48a17c0632f69c.png";